export default __webpack_public_path__ + "static/media/forest-bg.6be746fd.jpg";